var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',[_c('p',{staticClass:"copyright"},[_vm._v(" Copyright © "+_vm._s(_vm.currentYear)+" by "),_c('a',{attrs:{"href":"https://taiyi.me"}},[_vm._v("Tyean")]),_vm._v(". ")])])}
var staticRenderFns = []

export { render, staticRenderFns }